import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../notes/button/button.module';
import { DatagridModule } from '../../notes/datagrid/datagrid.module';
import { FormControlModule } from '../../notes/form-control/form-control.module';
import { IconModule } from '../../notes/icon/icon.module';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';
import { PaginatorModule } from '../../notes/paginator/paginator.module';
import { SidebarMainContainerModule } from '../../notes/sidebar-main-container/sidebar-main-container.module';
import { TabsModule } from '../../notes/tabs/tabs.module';

import { SidebarTableViewComponent } from './sidebar-table-view.component';

@NgModule({
  declarations: [SidebarTableViewComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DatagridModule,
    FormControlModule,
    IconModule,
    ModelAttributeModule,
    PaginatorModule,
    TabsModule,
    SidebarMainContainerModule,
  ],
  exports: [SidebarTableViewComponent],
})
export class SidebarTableViewModule {}
